import { BuildInAppToolId } from '../types/appTools';

export const AppToolbarIdConfig = {
    [BuildInAppToolId.Messages]: BuildInAppToolId.Messages,
    [BuildInAppToolId.SessionChats]: BuildInAppToolId.SessionChats,
    [BuildInAppToolId.Meetings]: BuildInAppToolId.Meetings,
    [BuildInAppToolId.SupportChat]: BuildInAppToolId.SupportChat,
};
